// src/constants.js

// API Endpoints
//export const API_BASE_URL = 'http://localhost:5001/api/';
export const API_BASE_URL = 'https://hubble-edocs-stag-api.hubblehox.ai/api/';
//export const API_BASE_URL = 'https://docuexprt.azurewebsites.net/api/';

export const API_ROUTES = {
  LOGIN: 'login',
  GetDocumentDetails:'getDocumentDetails',
  SingleFileUpload: 'singleFileUpload',
  GetDocumentListForInstitute: 'getDocumentListForInstitute',
  GetKeysFromJsonString:"getKeysFromJsonString",
  GetDataFromSearchText:'getDataFromSearchText',
  GetAllCustomDocuments:'getAllCustomDocuments',
  CustomDocumentVerify:'customDocumentVerify',
  CreateCustomDocument:'createCustomDocument',
  InsertIntoHybrid:'insertIntoHybrid',
  Index:'index',
  UpdateCustomDocumentName:'updateCustomDocumentName',
  DeleteCustomDocumentByName:'deleteCustomDocumentByName',
  GetAllLabelListForCustomDocument:'getAllLabelListForCustomDocument',
  SaveTagsAndInsertRawText:'saveTagsAndInsertRawText',
  AddNewLabelForCustomDocument:'addNewLabelForCustomDocument',
  UpdateLabelNameForCustomDocument:'updateLabelNameForCustomDocument',
  DeleteLabelForCustomDocument:'deleteLabelForCustomDocument',
  TestResultForNonCustomConstraint:'testResultForNonCustomCosnstraint',
  InsertUpdateFinalConstraintData:'insertUpdateFinalConstraintData',
  GetAllConditionData:'getAllConditionData',
  DeleteFinalConstraintData:'deleteFinalConstraintData',
  GetAllRolesForInstitute:'GetAllRolesForInstitute',
  InsertRoles:'insertRoles',
  UpdateUserRole:'updateUserRole',
  GetUserTypeFromEmailID:'getUserTypeFromEmailID',
  GetAnalysisForDashboard:'getAnalysisForDashboard',
  AllLogsWithDateTime:'allLogsWithDateTime',
  DeleteUserRole:'deleteUserRole',
  GETALLINSTITUTES:'getAllInstitutes',
  ADDINSTITUTE:'addInstitute',
  UPDATEINSTITUTE:'updateInstitute',
  DELETEINSTITUTE:'deleteInstitute',
  GETDEPARTMENTS:"getDepartments",
  GETDEPATMENTSWITHPAGINATION:"getDepartmentsWithPagination",
  GETALLDEPARTMENTS:"getAllDepartments",
  GETALLSUBDEPARTMENTS:"getSubDepartments",
  GETDEPATMENTS:"getDepartments",
  CREATEDEPARTMENT:"Createdepartment",
  UPDATEDEPARTMENT:"updateDepartment",
  DELETEDEPARTMENT:"deleteDepartment",
  GETSUBDEPARTMENTWITHPAGINATION:"getSubDepartmentWithPagination",
  CREATESUBDEPARTMENT:"Createsubdepartment",
  UPDATESUBDEPARTMENT:"updateSubDepartment",
  DELETESUBDEPARTMENT:"deleteSubDepartment",
  CREATEUSER:"createUser",
  UPDATEUSER:"updateUser",
  DELETEUSER:"deleteUser",
  GETALLUSERS:"getAllUsers",
  GETUSERASSIGNMENTSBYUSERID:"getUserAssignmentsByUserId",
  GETALLACTIVEINSTITUTES:"getAllActiveInstitutes",
  CREATEUSERASSIGNMENT:"createUserAssignment",
  DELETEUSERASSIGNMENT:"deleteUserAssignment",
  UPDATEAPPROVALSTATUSFORUSERASSIGNMENT:"updateApprovalStatusForUserAssignment",
  getDepartmentWiseDocumentCount:'getDepartmentWiseDocumentCount',
  getSubDepartmentWiseDocumentCount:'getSubDepartmentWiseDocumentCount',
  getInstituteWiseUserStatusChart:'getInstituteWiseUserStatusChart',
  getDepartmentWiseApprovalStatusCount:'getDepartmentWiseApprovalStatusCount',
  getInstituteWiseRoleCount:'getInstituteWiseRoleCount',
  getDepartmentWiseUploadedDocumentCount:'getDepartmentWiseUploadedDocumentCount',
  getDocumentUpdateTrend:'getDocumentUpdateTrend',
  getDepartmentWiseUserStatusChart:'getDepartmentWiseUserStatusChart',
  getUserActionLogsController:'getUserActionLogsController',
  getUserActionTypesController:'getUserActionTypesController',
  UpdateSearchResults:'updateSearchResults',
  GETUSERIDBYEMAIL:'getUserIdByEmail',
  REFRESH_TOKEN: `${API_BASE_URL}/token`,
  LOGOUT: `${API_BASE_URL}/logout`,
  // Add more API routes here
};

// App Routes
export const APP_ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  CONTACT: '/contact',
  LOCATION: '/location',
  CITY: '/city',
  LOGOUT: '/logout',
  // Add more app routes here
};


export const USER_ROLES = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  DEPARTMENT_HEAD: "DepartmentHead",
  OBSERVER: "Observer",
  DOCUMENT_MANAGER: "DocumentManager",
  SCANNER: "Scanner"
};


export const USER_SELECTION = {
  SUPER_ADMIN:[USER_ROLES.ADMIN,USER_ROLES.DEPARTMENT_HEAD,USER_ROLES.OBSERVER,USER_ROLES.DOCUMENT_MANAGER,USER_ROLES.SCANNER],
  ADMIN:[USER_ROLES.DEPARTMENT_HEAD],
  DEPARTMENT_HEAD:[USER_ROLES.DOCUMENT_MANAGER,USER_ROLES.OBSERVER,USER_ROLES.SCANNER]
}